<template>
    <div class="featured-data-wrapper">
        <PtIcon icon="SolidLoadingBars" v-if="isLoading"/>
        <template v-else>
            <div class="featured-data-left" v-if="list.length>0">
                <div
                    v-for="(item) in list"
                    :key="item.id"
                    :class="{'active':currentId === item.id}"
                    class="featured-data-item"
                    @click="handleChange(item.id)"
                >
                    {{ item.title }}
                </div>
            </div>
            <div class="featured-data-right">
                <PtIcon icon="SolidLoadingBars" v-if="resultLoading"/>
                <template v-else>
                    <img :src="require(`./../../assets/dataProductionPanorama_${currentLang==='CN'?'CN':'EN'}.gif`)"
                         v-if="currentId==='dataProductionPanorama'"/>
                    <div v-html="result" v-else></div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import {
    featureDataItemById,
    featureDataList,
} from '../../../../../../../../components/apis/core_basic_api/data_coverage';
import { RavenInsertMeta } from 'library-@/services/sentry';

/**
 * 特色数据
 */
export default {
    name: 'FeaturedData',
    components: {
        PtIcon
    },
    data() {
        return {
            currentId: '',
            currentLang: this.$i18n.locale.toUpperCase(),
            list: [],
            result: '',
            isLoading: false,
            resultLoading: false,
        };
    },
    methods: {
        handleChange(id) {
            this.currentId = id;
            this.result = '';
            if (id === 'dataProductionPanorama') {
                return;
            }
            this.featureDataItemById(id);
        },
        async init() {
            try {
                this.isLoading = true;
                let list = await featureDataList();
                list.forEach(item => item.id = item.featured_data_id);
                list.unshift({ id: 'dataProductionPanorama', title: this.$t('featuredData.dataProductionPanorama') });
                this.list = list;
                this.handleChange(list[0].id);
            } finally {
                this.isLoading = false;
            }
        },
        async featureDataItemById(id) {
            try {
                this.resultLoading = true;
                let res = await featureDataItemById(id);
                if (this.currentId === res.id) {
                    this.result = res.content;
                    this.resultLoading = false;
                }
            } catch (e) {
                this.resultLoading = false;
            }
        }
    },
    created() {
        this.init();
        RavenInsertMeta('Data Coverage', 'View Featured Data');
    }
};

</script>

<style lang="scss">
@import "@patsnap-biz/design-tokens/scss/scrollBar";

body {
    background: $bg-white;
}

.featured-data-wrapper {
    position: relative;
    width: 1280px;
    margin: 10px auto 0;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    min-height: calc(100vh - 172px);

    .featured-data-left {
        position: sticky;
        top: 64px;
        width: 252px;
        height: 560px;
        overflow-y: auto;
        @include scroll-bar;
        background: $bg-white;
        box-shadow: 5px 5px 40px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 8px;
        box-sizing: border-box;

        .featured-data-item {
            line-height: 20px;
            padding: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #061632;
            cursor: pointer;
            border-radius: 4px;


            &.active {
                background: #505F79 !important;
                color: $text-white;
            }

            &:hover {
                background: rgba(179, 186, 197, 0.2);
            }
        }
    }

    .featured-data-right {
        text-align: left;
        margin-left: 24px;
        line-height: 1.6;
        font-size: 14px;
        word-wrap: break-word;
        width: 924px;
        padding-bottom: 20px;

        img {
            max-width: 100% !important;
            height: auto !important;
        }
    }

    .patsnap-biz-icon {
        &[icon="SolidLoadingBars"] {
            fill: $fill-normal !important;
            font-size: 48px;
            display: block;
            margin: 200px auto 0;
        }
    }
}
</style>
